import {game} from "../main";

export function stopTweens(obj) {
  // @ts-ignore
  [].concat(game.tweens._tweens, game.tweens._add)
    .forEach((tween: Phaser.Tween) => {
      if (obj.scale && tween.target == obj.scale) tween.stop();
      if (tween.target == obj) tween.stop();
    });
}
